import { Column } from '@components/Table/model/table';
import { FeedbackType, FeedbackTypeItem } from '@features/FeedbackTypeItem';
import { dateTimeFromString, sortByDate, sortByKey } from '@utils/utils';

const feedbackUserHeaderList: Column[] = [
  {
    name: 'Name',
    key: 'creator.name',
    sortMethod: sortByKey,
    width: '10%',
    sortable: true,
  },
  {
    name: 'Email',
    key: 'creator.email',
    sortMethod: sortByKey,
    width: '20%',
    sortable: true,
  },
  {
    name: 'Message',
    key: 'message.text',
    sortMethod: sortByKey,
    width: '55%',
    sortable: true,
  },
  {
    name: 'Type',
    key: 'feedback_type',
    sortMethod: sortByKey,
    width: '5%',
    sortable: true,
    wrapperFn: (feedback_type: FeedbackType) => (
      <FeedbackTypeItem feedback_type={feedback_type} />
    ),
  },
  {
    name: 'Date',
    key: 'created_at',
    sortMethod: sortByDate,
    sortable: true,
    width: '10%',
    wrapperFn: (dateString: Date) => (
      <p style={{ fontFamily: 'Inter-Regular', color: '#475467' }}>
        {dateTimeFromString(dateString)}
      </p>
    ),
  },
];

const getFeedbackUserHeaderList = () => feedbackUserHeaderList;

export default getFeedbackUserHeaderList;
